import React from "react";

export default function TermsConditions() {
  return (
    <div
      className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8"
      data-aos="fade-up"
    >
      <div className="max-w-5xl mx-auto bg-white shadow-lg rounded-2xl overflow-hidden">

        {/* Header */}
        <div className="bg-gradient-to-r from-orange-500 via-orange-600 to-amber-500 px-8 py-12 text-white">
          <h1 className="text-4xl font-bold mb-3">
            Terms & Conditions
          </h1>

          <p className="text-lg text-orange-100 max-w-2xl">
            Please read our terms and conditions carefully before
            using our website or services. By continuing, you agree
            to comply with our policies and service guidelines.
          </p>
        </div>

        {/* Content */}
        <div className="p-8 md:p-12 space-y-10 text-gray-700">

          {/* Introduction */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              1. Introduction
            </h2>
            <p className="leading-7 text-gray-600">
              By accessing or using the{" "}
              <strong>HOLLY ZOLLY</strong> website and services,
              you agree to comply with the following terms
              and conditions. These terms govern your use of
              our platform, products, and services.
            </p>
          </section>

          {/* Use of Services */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              2. Use of Services
            </h2>
            <p className="leading-7 text-gray-600">
              You agree to use our services only for lawful
              purposes. Any misuse, unauthorized access,
              fraudulent activity, or action that may damage
              our platform, services, or reputation is strictly
              prohibited.
            </p>
          </section>

          {/* Nature of Services */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              3. Nature of Services
            </h2>
            <p className="leading-7 text-gray-600">
              Vastukkalp provides Vastu consultation,
              guidance, and recommendations based on
              traditional principles. Results may vary
              depending on individual circumstances,
              implementation, and environmental factors.
            </p>
          </section>

          {/* Appointments & Payments */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              4. Appointments & Payments
            </h2>
            <p className="leading-7 text-gray-600">
              All consultations are subject to prior booking
              and confirmation. Fees once paid are subject
              to our cancellation and refund policy.
              Prices, service charges, and packages may
              change without prior notice.
            </p>
          </section>

          {/* Intellectual Property */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              5. Intellectual Property
            </h2>
            <p className="leading-7 text-gray-600">
              All content, reports, designs, recommendations,
              branding, and materials provided by Vastukkalp
              are our intellectual property and are intended
              for personal use only. Unauthorized copying,
              sharing, or reproduction is not permitted.
            </p>
          </section>

          {/* Limitation of Liability */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              6. Limitation of Liability
            </h2>
            <p className="leading-7 text-gray-600">
              Vastukkalp shall not be held liable for any
              direct or indirect outcomes resulting from
              the use of our consultation services.
              Clients are responsible for decisions made
              based on the guidance provided.
            </p>
          </section>

          {/* Changes to Terms */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              7. Changes to Terms
            </h2>
            <p className="leading-7 text-gray-600">
              We reserve the right to update, revise, or
              modify these terms at any time without
              prior notice. Continued use of our services
              after changes are posted signifies your
              acceptance of the updated terms.
            </p>
          </section>

          {/* Contact */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              8. Contact Us
            </h2>
            <p className="text-gray-600 leading-7">
              If you have any questions regarding these
              Terms & Conditions, please contact us.
            </p>

            <div className="mt-4 p-5 bg-gray-100 rounded-xl">
              <p>
                <span className="font-semibold">
                  Email:
                </span>{" "}
                vastukkalp2007gmail.com
              </p>

              <p>
                <span className="font-semibold">
                  Phone:
                </span>{" "}
                +91 99095 11961
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}